module.exports = {
	"id": "/schedule"
};


/*****************
 ** WEBPACK FOOTER
 ** ../src/config/message_schemas/triggers/schedule.json
 ** module id = 1832
 ** module chunks = 0
 **/